import React from 'react';
import iconLogo from '../../assets/logos/logo-icon.svg';
import horizontalLogo from '../../assets/logos/logo-horizontal.svg';
import stackedLogo from '../../assets/logos/logo-stacked.svg';
import stackedTaglineLogo from '../../assets/logos/logo-stacked-tagline.svg';

export type LogoVariant = 'icon' | 'horizontal' | 'stacked' | 'stacked-tagline';

const SOURCES: Record<LogoVariant, string> = {
    icon: iconLogo,
    horizontal: horizontalLogo,
    stacked: stackedLogo,
    'stacked-tagline': stackedTaglineLogo,
};

interface LogoProps {
    /** Which brand lockup to render. Defaults to the horizontal icon + wordmark. */
    variant?: LogoVariant;
    /** CSS height (e.g. 32, "2rem"). Width scales automatically. */
    maxHeight?: number | string;
    className?: string;
    style?: React.CSSProperties;
}

/**
 * ForceTracker brand logo. Dark-background lockups per /brand/CLAUDE.md — use on
 * the app's dark surfaces. See the brand guide for light/mono variants.
 */
const Logo: React.FC<LogoProps> = ({
    variant = 'horizontal',
    maxHeight = 40,
    className,
    style,
}) => (
    <img
        src={SOURCES[variant]}
        alt="ForceTracker"
        className={className}
        style={{ maxHeight, width: 'auto', ...style }}
    />
);

export default Logo;
